import { render, staticRenderFns } from "./finRes.vue?vue&type=template&id=ec7ebfe0&scoped=true"
import script from "./finRes.vue?vue&type=script&lang=ts"
export * from "./finRes.vue?vue&type=script&lang=ts"
import style0 from "./finRes.vue?vue&type=style&index=0&id=ec7ebfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7ebfe0",
  null
  
)

export default component.exports